import React, { useEffect, useCallback, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Button,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
    DragDropContext,
    Droppable,
    Draggable
} from "@hello-pangea/dnd";
import { IoClose } from "react-icons/io5";
import "../../../css/Administrador/FuncionesGenerales.css"
import { useUserAdmin } from "../../../admin/UserContext";
import { CrearPortadaNosotros } from "./CrearPortadaNosotros";
import { EditarPortadaNosotros } from "./EditarPortadaNosotros";

export const PaginaPortadaNosotrosindexAdmin = () => {
   const { Token } = useUserAdmin();
    const [sliders, setSliders] = useState([]);
    const [ModalCrear, setModalCrear] = useState(false)
    const [ModalEditar, setModalEditar] = useState(false)
    const [SliderSelecion, setSliderSelecion] = useState([])
    const backendURL = process.env.REACT_APP_BACKEND_URL;

    const handleAbrirModalEditar = (id) => {
        setSliderSelecion(id)
        setModalEditar(true);
    };
    const handleAbrirCrearSlider = () => {
        setModalCrear(true);
    };

    const fetchSliders = useCallback(async () => {
    try {
      const response = await axios.get(`${backendURL}/api/portada-nosotros/admin`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setSliders(response.data);
    } catch (error) {
      console.error("Error al obtener sliders:", error);
    }
  }, [Token, backendURL]);

  // Llamada inicial a sliders cuando hay token
  useEffect(() => {
    if (Token) {
      fetchSliders();
    }
  }, [Token, fetchSliders]);

 


    const handleDelete = async (id) => {
        if (window.confirm('¿Estás seguro de que deseas eliminar este banner?')) {
            try {
                 await axios.delete(`${backendURL}/api/eliminar/portada-nosotros/${id}`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            });
            
                fetchSliders();
            } catch (error) {
                console.error("Error al eliminar el banner:", error);
                alert("Ocurrió un error al eliminar el banner.");
            }
        }
    };
    return (
        <Box p={3}>
            <Typography variant="h4" gutterBottom sx={{ color: "#585857", fontWeight: 600 }}>
                Portada nosotros 
            </Typography>
    {sliders.length === 0 ? (
            <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleAbrirCrearSlider}
                sx={{
                    color: "#fff",
                    background: "#5E487B",
                    textTransform: "capitalize",
                    marginTop: "20px",
                    marginBottom: "30px"
                }}
            >
                Crear nueva informaciòn de portada
            </Button>):(
                <>
                </>
            )}

            <TableContainer component={Paper} sx={{ background: '#b2dfdb' }}>
                {sliders.length === 0 ? (
                    <Box p={3} textAlign="center" >
                        <Typography variant="subtitle1" sx={{ color: "#888" }}>
                            No hay sliders agregados.
                        </Typography>
                    </Box>
                ) : (
                    <DragDropContext>
                        <Droppable droppableId="slider-table">
                            {(provided) => (
                                <Table {...provided.droppableProps} ref={provided.innerRef} sx={{ color: '#585857' }}>
                                    <TableHead sx={{ backgroundColor: '#80cbc4' }}>
                                        <TableRow>
                                           
                                            <TableCell sx={{ color: '#585857' }}>Imagen </TableCell>
                                            <TableCell sx={{ color: '#585857' }}>titulo</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>subtitulo</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>parrafo</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>parrafo 2</TableCell>
                                             <TableCell sx={{ color: '#585857' }}>parrafo 3</TableCell>
                                              <TableCell sx={{ color: '#585857' }}>parrafo 4</TableCell>
                                            <TableCell sx={{ color: '#585857' }}>Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sliders.map((slider, index) => (
                                            <Draggable key={slider.id} draggableId={slider.id.toString()} index={index}>
                                                {(provided, snapshot) => (
                                                    <TableRow
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        sx={{
                                                            background: snapshot.isDragging ? "#e0e0e0" : "#b2dfdb",
                                                            cursor: "grab"
                                                        }}
                                                    >

                                                        <TableCell>
                                                            {slider.imagen && (
                                                                <img
                                                                    src={`${backendURL}/${slider.imagen}`}
                                                                    alt="Fondo"
                                                                    style={{ width: "80px", height: "auto", borderRadius: 4 }}
                                                                />
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            {slider.titulo}
                                                        </TableCell>
                                                        <TableCell>
                                                            {slider.subtitulo}
                                                        </TableCell>
                                                        <TableCell>
                                                           {slider.parrafo}
                                                            {slider.parrafo_destacado}
                                                        </TableCell>
                                                         <TableCell>
                                                           {slider.parrafo2}
                                                            {slider.parrafo2_destacado}
                                                        </TableCell>
                                                         <TableCell>
                                                           {slider.parrafo3}
                                                            {slider.parrafo3_destacado}
                                                        </TableCell>
                                                         <TableCell>
                                                           {slider.parrafo4}
                                                            {slider.parrafo4_destacado}
                                                        </TableCell>
                                                        <TableCell>
                                                            <Button
                                                                size="small"

                                                                onClick={() => handleAbrirModalEditar(slider.id)}
                                                                startIcon={<EditIcon />}
                                                                sx={{ marginRight: 1, background: '#ffcc80', color: '#fff', textTransform: "capitalize" }}
                                                            >
                                                                Editar
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                onClick={() => handleDelete(slider.id)}
                                                                startIcon={<DeleteIcon />}
                                                                sx={{ marginRight: 1, background: '#b71c1c', color: '#fff', textTransform: "capitalize" }}
                                                            >
                                                                Eliminar
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </TableBody>
                                </Table>
                            )}
                        </Droppable>
                    </DragDropContext>
                )}
            </TableContainer>

            {/* modal crear slider */}
            <Modal open={ModalCrear} onClose={() => setModalCrear(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 700,
                        bgcolor: '#fff',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                >
                    <section className="closemodal" onClick={() => setModalCrear(false)}>
                        <IoClose />
                    </section>
                 <CrearPortadaNosotros fetchSliders={fetchSliders} onclose={() => setModalCrear(false)} /> 

                </Box>
            </Modal>
            {/* Modal editar */}
            <Modal open={ModalEditar} onClose={() => setModalEditar(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 700,
                        bgcolor: '#fff',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                >
                    <section className="closemodal" onClick={() => setModalEditar(false)}>
                        <IoClose />
                    </section>
               <EditarPortadaNosotros fetchSliders={fetchSliders} slider={SliderSelecion} onclose={() => setModalEditar(false)} />

                </Box>
            </Modal>
        </Box>
    );
};